<div class="container-integration__fieldset form-filter-fieldset col-xs-12 col-9">
    <msc-input type="text" [label]="'organize.integration.rule-name' | translate" [(ngModel)]="rule.name" (input)="onInputChange()"></msc-input>
</div>
